import React, { FC } from 'react';
import classNames from 'classnames';

import { useTranslation } from 'app/lang';
import { formatPrice } from 'app/lib/formatters';

import dictionary from './PriceDiff.dictionary.json';

import styles from './PriceDiff.module.scss';

// ---

type PriceDiffProps = {
  prev?: number;
  next?: number;
  className?: string;
  'data-test'?: string;
};

const PriceDiff: FC<PriceDiffProps> = ({
  prev,
  next,
  className,
  ...props
}) => {
  if (!prev && !next) {
    return null;
  }

  const dataTest = props['data-test'];
  const _defaultClassName = classNames(styles.price, className);

  if (!prev && next) {
    return PriceComponent(next, _defaultClassName, dataTest);
  }

  if (prev && !next) {
    return PriceComponent(prev, _defaultClassName, dataTest);
  }

  const nextValue = next as number; // Сделал проверки выше, но TS их не видит
  const prevValue = prev as number;

  const increased = nextValue > prevValue;
  const decreased = nextValue < prevValue;

  const _className = classNames({
    [styles.increased]: increased,
    [styles.decreased]: decreased,
  }, _defaultClassName);

  const value = (increased || decreased) ? nextValue : prevValue;

  return PriceComponent(value, _className, dataTest);
};

// ---

function PriceComponent(
  value: number,
  className: string,
  dataTest?: string,
): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className={className}
         title={t(dictionary.title)}
         data-test={classNames(dataTest, 'priceDiff-container')}>
      {formatPrice(value)}
    </div>
  );
}

export default PriceDiff;
